module.exports = __webpack_public_path__ + "img/2.59249a08.png";